export const INFO_COLLECTION_DEFAULT_VALUES = {
  firstName: '',
  lastName: '',
  email: '',
  company: '',
};

export const VALIDATION_MESSAGES = {
  invalidEmail: 'Invalid email address',
  required: 'This field is required',
};
